import * as React from 'react';
import { useContext, useState} from 'react'; 
import Dialog  from '@material-ui/core/Dialog'; 
import styles from './styles.module.css'; 
import Skeleton from '@material-ui/lab/Skeleton'
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import {DealerDetailsContext} from '@/context/dealerDetailsContext'
import userService from '@/utils/services/user'
import { useDispatch } from 'react-redux';
import { setIsDealerUpdatingAddrAction } from '@/store/actions/dealer';
import AppContext from '@/AppContext'; 
import ModalDealerContactForm from '../ModalDealerContactForm';
import ModalCompanyDealerSection from '../ModalDealerCompanySection';
import { CircularProgress, Divider, makeStyles } from '@material-ui/core'; 
import { formatZipCode } from '@/utils/helpers/formatZipCode';

export interface DealerDetailsUpdate {
  open: boolean;  
}

export function DealerDetailsUpdate(props: DealerDetailsUpdate) {
  const { open } = props;
  const { trigger,isLoading,formState: { errors },setError,getValues,userId,clearErrors} = useContext(DealerDetailsContext)
  const dispatch=useDispatch()
  const { setToast, fireToast } = useContext(AppContext) 
  const [isSubmitting,setSubmitting] = useState(false)

  const updateDealerData=async(value)=>{ 
      const data = {
        dealer: {
            first_name: value['first_name'],
            last_name: value['last_name'],
            phone: value['phone_number'],
            email: value['emailId']
        },
      dealer_company: {
            id: (value['companyId']>0)?value['companyId']:0,
            manufacturer_id: value['manufacturerIdSelected'],
            name: value['company_name'],
            phone: value['company_phone'],
            email: value['company_email'],
            state_id: value['company_state_id'],
            address1: value['company_street'],
            city: value['company_city'],
            zip: formatZipCode(value['company_zip_code']),
            address_apt: value['company_address_apt']||"",
            county: value['company_county']??"",
            is_verified:value['is_verified']||false
        } 
    } 
    
    try{ 
        const response=await userService.updateDealerDetails(data,userId)   
        dispatch(setIsDealerUpdatingAddrAction(false))   
        setToast('success', 'Dealer details updated successfully')
        fireToast(true)
    }
    catch(error){ 
        if(error.response.status===422){
          setToast('error', error.response.data.message)
        }
        else{
          setToast('error', 'Error in updating Dealer details')
        }
        fireToast(true)
    } 
    finally{
      setSubmitting(false)
    }
    
  }
  
  const handleSubmit = async () => { 
    clearErrors()
    const isValid = await trigger();  
    if (isValid) {   
      const values = getValues(); 

    let customIsValid = true;

    if (values['company_street'] === '') {
      setError('company_street', { type: 'manual', message: `Company Address is required` });
      customIsValid = false;
    }

    for (const [field, value] of Object.entries(values)) { 
      if (field.includes('phone') && typeof value ==='string') {
        const strippedPhoneNumber = value.replace(/\D/g, '');

        if (strippedPhoneNumber.length !== 10) {
          setError(field, { type: 'manual', message: 'Phone number must have 10 digits' });
          customIsValid = false;
        } 
      } else if (field.includes('email') && typeof value === 'string') {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(value)) {
          setError(field, { type: 'manual', message: 'Invalid email address' });
          customIsValid = false;
        }
        else if(value===""){
          setError(field, { type: 'manual', message: `${field} is required` });
        }
      }
        else if (value === '' && (!field.includes('address_apt') && !field.includes('county'))) { 
        setError(field, { type: 'manual', message: `${field} is required` });
        customIsValid = false;
      }
    }

    if (customIsValid) { 
      setSubmitting(true)
      updateDealerData(values);
    }   
  }
    if (!isValid) { 
       return
    }
  };

  return (
    <>
      <Dialog
        // fullWidth={true}
        maxWidth="md" 
        PaperProps={{
          style: {
            height: 627,
            borderRadius: '15px',
            width: 1305,
            zIndex:1300
          },
        }}
        open={open}>
        <DialogContent>
          <div className={styles.updateForm}>
            <div>
              <p className={styles.modalWelcome}>Welcome!</p>
              <p className={styles.modalWelcome2}>Please complete your profile to continue.</p>
            </div>
            {!isLoading ?
              <>
                <ModalCompanyDealerSection />
                <Divider className={styles.divider} />
                <ModalDealerContactForm />
                <Button
                  variant="contained"
                  color="primary"
                  type="button"
                  onClick={handleSubmit}
                  classes={{ root: `${styles.button} ${styles.submit} ${styles.submitBtn}` }}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                </Button></>
              : <Skeleton variant="rect" animation="wave" width="800px" height="400px" />}
          </div>
        </DialogContent>
      </Dialog>  
        </> 
  );
}
 